import { render, staticRenderFns } from "./RemoveFromSegment.vue?vue&type=template&id=771ae16e"
import script from "./RemoveFromSegment.vue?vue&type=script&lang=js"
export * from "./RemoveFromSegment.vue?vue&type=script&lang=js"
import style0 from "./RemoveFromSegment.vue?vue&type=style&index=0&id=771ae16e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports